module.exports = __webpack_public_path__ + "static/media/11.ebb66d6c.png";